import PencilOutline from '@simplywallst/ui-core/icons/PencilOutline';

type Props = {
  onClick: () => void;
};

export const FeedCardMyFairValueUnset = ({ onClick }: Props) => {
  return (
    <button
      className="group/fv focus-outline grid grid-cols-[max-content_max-content_max-content] items-center gap-x0_5 rounded-md"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
    >
      <span className="text-xs text-softer group-hover/fv:text-soft">
        My Fair Value
      </span>
      <span className="text-xs text-accent group-hover/fv:brightness-125">
        Select<span className="hidden min-[450px]:inline"> Narrative</span>
      </span>
      <PencilOutline className="size-x2 fill-accent group-hover/fv:brightness-125" />
    </button>
  );
};
